(function (Drupal, $, once) {

  Drupal.behaviors.megamenu = {
    attach: function (context, settings) {

      const $window = $(window);
      const $body = $('body');
      const $header = $('#header');
      const $menu_toggle = $('.burger-menu-btn', $header);
      const $megamenu = $('.megamenu', $header);
      const $megamenu_has_active_item = $megamenu.find('.menu-level-0 > .menu-item.menu-item--active-trail');
      const $megamenu_items = $megamenu.find('.menu-level-0 > .menu-item > .submenu-opener');
      const $megamenu_visuals = $megamenu.find('.image_wrapper');
      const $overlay = $('.megamenu-overlay', $header);
      const $lang_switcher = $('#block-languageswitcher');
      const langSwitch = $('.links > div > .lang-opener', $lang_switcher);
      const $megamenu_footer = $('.megamenu-footer', $megamenu);
      const $main_nav = $('.navigation-container', $header);
      const mobile_breakpoint = (window.devicePixelRatio >= 1.5) ? 1215 : 1279;
      let megamenu_height = 0;

      // remove whitespace from header cta so it can hide if it is empty
      const $header_cta = $header.find('.cta-container');
      let header_cta_content = $header_cta.html()?.trim();
      $header_cta.html(header_cta_content);

      // get window width
      const is_mobile = function(){
        return window.innerWidth <= mobile_breakpoint;
      };

      // calculate height of megamenu
      const get_megamenu_height = function(){
        $megamenu.css({'visibility':'hidden', 'display':'block'});
        megamenu_height = $megamenu.outerHeight(true);
        $megamenu.css({'visibility':'visible', 'display':'none'});
      };
      get_megamenu_height();

      // open megamenu
      function open_megamenu(triggerEl){
        $header.addClass('megamenu-is-open');
        $megamenu.addClass('megamenu-is-open');
        $menu_toggle.addClass('megamenu-is-open');
        $menu_toggle.attr('aria-expanded', 'true');
        $overlay.show();
        $body.addClass('no-scroll');
        let header_position_top = $header.position().top;
        let header_offset = header_position_top + $header.outerHeight(true);

        // set current item if on a subpage
        if($megamenu_has_active_item){
          $megamenu_has_active_item.find('.submenu-opener').trigger('mouseover');
        } else {
          $megamenu_items.eq(0).trigger('mouseover');
        }

        if(is_mobile()){
          $megamenu.show();
          resize_header();
        } else {
          if(megamenu_height + header_offset > window.innerHeight){
            $megamenu.addClass('needs-to-scroll');
            // force visual containers to full height of the megamenu container
            $megamenu_visuals.height(megamenu_height);
          }
          // $body.addClass('no-scroll');
          $megamenu.slideDown('fast');
        }
        let menuText = $(triggerEl).text().trim().toLowerCase().replace(/\s+/g, '_');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'gtm.custom_event',
          'event_name': 'click_' + menuText,
          'event_category': 'Navigation',
          'event_label': 'undefined',
          'event_location': 'Nav'
        });

        if(!is_mobile()){
          setTimeout(function (){
            $header.on('click.megamenu_clickout tap.megamenu_clickout', function(e){
              if(
                e.target.id === "header" ||
                e.target.classList.contains("logo-wrapper") ||
                e.target.classList.contains("header-logo") ||
                e.target.classList.contains("cta-container") ||
                e.target.classList.contains("search-icon-btn")
              ){
                close_megamenu();
              }
            });
          }, 500);
        }
      }

      // close megamenu
      function close_megamenu(){
        $header.removeClass('megamenu-is-open');
        $megamenu.removeClass('megamenu-is-open');
        $menu_toggle.removeClass('megamenu-is-open');
        $menu_toggle.attr('aria-expanded', 'false');
        $body.removeClass('no-scroll');
        $overlay.hide();
        $header.css({ height: '' });

        if(is_mobile()){
          $megamenu.hide();
          $megamenu.find('.active-mobile').removeClass('active-mobile');
          $megamenu.find('.active').removeClass('active');
          $megamenu.find('.menu-level-0 > .menu-item:first-child').addClass('active');
          $('.menu-dropdown-0', $megamenu).hide();
          $megamenu.attr('data-current', '');
        } else {
          $megamenu.slideUp('fast', function(){
            $megamenu.removeClass('needs-to-scroll');
            $megamenu_visuals.height('');
            $megamenu.find('.active').removeClass('active');
            $megamenu.find('.menu-level-0 > .menu-item:first-child').addClass('active');
            $megamenu.attr('data-current', '');
          });
        }
        $header.off('click.megamenu_clickout tap.megamenu_clickout');
      }

      function focus_event_listener (event){
        if(!event.target.classList.contains('language-link')){
          close_lang_switcher();
        }
      }

      // open language switcher
      function open_lang_switcher(){
        $lang_switcher.addClass('language-is-open');
        document.addEventListener('focusin', focus_event_listener);
        langSwitch.attr('aria-expanded', 'true');
      }

      // close language switcher
      function close_lang_switcher(){
        $lang_switcher.removeClass('language-is-open');
        document.removeEventListener('focusin', focus_event_listener);
        langSwitch.attr('aria-expanded', 'false');
      }

      // make sure the open header has the correct height on tablet and mobile
      function resize_header(){
        if(is_mobile() && $header.hasClass('megamenu-is-open')){
          $header.css({ height: (window.innerHeight - $header.position().top) });
        }

        // force close the header if we go to desktop size
        if( !is_mobile() && $header.hasClass('megamenu-is-open') ){
          close_megamenu();
        }
      }
      // Can not use `window` or `document` directly.
      // @see https://www.drupal.org/node/3158256
      if (!once('mobile-header-resizer', 'html').length) {
        // Early return avoid changing the indentation
        // for the rest of the code.
        return;
      }
      $window.on('resize', resize_header);

      if($lang_switcher.length){
        $lang_switcher.find('.lang-links li.is-active a').attr('aria-current', 'true');
        $(once('language-toggle', langSwitch)).click(function(e){
          e.preventDefault();
          if($lang_switcher.hasClass('language-is-open')){
            close_lang_switcher();
            $lang_switcher.off('mouseleave');
          } else {
            open_lang_switcher();
            if(!is_mobile()){
              $lang_switcher.on('mouseleave', close_lang_switcher);
            }
          }
        });
      }

      $(once('megamenu-toggle', $menu_toggle)).on('click', function(){
        if($megamenu.hasClass('megamenu-is-open')){
          close_megamenu();
        }
        else {
          open_megamenu(this);
        }
      });

      $(once('megamenu-overlay-click', $overlay)).on('click', close_megamenu);

      // switch active category in megamenu
      $megamenu_items.each(function(){
        const $item = $(this);
        const $parent = $item.parent();

        //for desktop
        $(once('megamenu-mouseover', $item)).on('mouseover', function (){
          if(!$parent.hasClass('active') && !is_mobile()){
            $parent.siblings().removeClass('active');
            $parent.siblings().find("[role='button']").attr('aria-expanded', 'false');
            $parent.addClass('active');
            $item.find("[role='button']").attr('aria-expanded', 'true');
            $megamenu.attr('data-current', $parent.index()+1);
          }
        });

        //for mobile
        $(once('megamenu-submenu-mobile-click', $item)).on('click', function (e){
          e.preventDefault();
          if(!$parent.hasClass('active-mobile') && is_mobile()){
            $parent.siblings().removeClass('active active-mobile');
            $parent.addClass('active active-mobile');
            $parent.siblings().find('.menu-dropdown-0').hide();
            $item.siblings('.menu-dropdown-0').slideDown('fast');
          }
          else if($parent.hasClass('active-mobile') && is_mobile()){
            $parent.removeClass('active active-mobile');
            $item.siblings('.menu-dropdown-0').hide();
          }
        });

        //on focused and tap on enter or space
        $item.find("[role='button']").on("focus", function (){
          $item.find("[role='button']").on("keyup", function (e){
            if((e.which === 13 || e.which === 32) && !$parent.hasClass('active') && !is_mobile()){
              $parent.siblings().removeClass('active');
              $parent.siblings().find("[role='button']").attr('aria-expanded', 'false');
              $parent.addClass('active');
              $item.find("[role='button']").attr('aria-expanded', 'true');
              $megamenu.attr('data-current', $parent.index()+1);
            }
          });
        });
      });

      // move main nav on resize
      let nav_is_mobile = false;
      if (!once('megamenu-window-resize', 'html').length) {
        return;
      }
      $window.on('resize', function(){
        if(is_mobile() && nav_is_mobile === false){
          $main_nav.insertBefore($megamenu_footer);
          nav_is_mobile = true;
        } else if(is_mobile() === false && nav_is_mobile) {
          $main_nav.insertAfter($megamenu);
          $megamenu.find('.active-mobile').removeClass('active-mobile');
          $megamenu.find('.menu-dropdown-0').hide().css('display', '');
          nav_is_mobile = false;
        }
      }).trigger('resize');

      // open megamenu when enter is pressed on focused menu
      $menu_toggle.on("focus", function (){
        $menu_toggle.on('keyup', function(e){
          if(e.which === 13){
            if($header.hasClass('megamenu-is-open') ){
              close_megamenu();
            } else {
              open_megamenu(this);
            }
          }
        });
      });

      $menu_toggle.on("blur", function (){
        $menu_toggle.off('keyup');
      });
    }
  };

})(Drupal, jQuery, once);
